import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router, CanActivate } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    var accessCode = localStorage.getItem("AccessCode");
      if (accessCode){
        return true;
      } else {
        this.router.navigate(['/auth/login']);      
        return false;
      }
  }
}
